import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, formatDate } from "@/lib/api";
import { FadeUp, Kicker } from "@/components/Reveal";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/posts/${slug}`)
      .then((r) => { setPost(r.data); document.title = `${r.data.title} — Luca Mannu Giardini`; })
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound)
    return (
      <main className="mx-auto max-w-3xl px-6 pb-32 pt-48 text-center" data-testid="post-not-found">
        <h1 className="font-serif text-4xl text-forest">Articolo non trovato</h1>
        <Link to="/blog" className="link-underline mt-6 inline-block font-accent text-xs uppercase tracking-[0.2em] text-terra">Torna al blog</Link>
      </main>
    );

  if (!post)
    return <main className="mx-auto max-w-3xl px-6 pb-32 pt-48 text-sage" data-testid="post-loading">Caricamento…</main>;

  return (
    <main data-testid="blog-post-page">
      <header className="relative flex min-h-[70vh] items-end overflow-hidden bg-forest">
        <img src={post.image} alt={post.title} className="absolute inset-0 h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest via-forest/40 to-transparent" />
        <div className="relative z-10 mx-auto w-full max-w-4xl px-6 pb-16 lg:px-10">
          <FadeUp>
            <Link to="/blog" className="flex w-fit items-center gap-2 font-accent text-xs uppercase tracking-[0.2em] text-bone/70 hover:text-bone" data-testid="post-back-link">
              <ArrowLeft className="h-4 w-4" strokeWidth={1.5} /> Tutti gli articoli
            </Link>
            <Kicker className="mt-8">{post.category} · {formatDate(post.created_at)}</Kicker>
            <h1 className="mt-4 font-serif text-4xl leading-tight tracking-tight text-bone md:text-6xl" data-testid="post-title">{post.title}</h1>
          </FadeUp>
        </div>
      </header>
      <article className="mx-auto max-w-3xl px-6 py-20 lg:px-10" data-testid="post-content">
        <p className="font-serif text-2xl italic leading-relaxed text-moss">{post.excerpt}</p>
        <div className="mt-10 flex flex-col gap-7">
          {post.content.split(/\n+/).filter(Boolean).map((para, i) => (
            <p key={i} className="text-lg leading-relaxed text-forest/80">{para}</p>
          ))}
        </div>
        <div className="mt-16 border-t border-line pt-10">
          <p className="font-accent text-xs uppercase tracking-[0.25em] text-terra">Scritto da</p>
          <p className="mt-2 font-serif text-2xl text-forest">Luca Mannu</p>
          <p className="mt-1 text-sm text-sage">Giardiniere e paesaggista, Cagliari</p>
        </div>
      </article>
    </main>
  );
}
